import { Controller } from "../Controller";
import { MenuItem } from "./MenuItem";
import { ControllerRegistry } from "../../Registry/ControllerRegistry";
import { Container as MenuGridTag } from "../../HTML/Container/Container";
import { toMap } from "../../../../HA";

export class Menu extends Controller {

    /**
     * @param data
     */
    protected initialize(data: Map<any, any>) {
        super.initialize(data);
        this.addToData("tag", new MenuGridTag(toMap(data)));
        this.initializeItems();
    }

    protected initializeItems() {
        this.addToData("itemControllers", new Map());
        const items = this.getItems();
        if (items) {
            items.forEach((item: any) => {
                this.addItem(toMap(item));
            });
        }
    }

    /**
     *
     * @param data
     */
    protected addItem(data: Map<any, any>) {
        const config = toMap(data);
        config.set("services", this.getItemService());
        config.set("pelement", this.get("tag"));
        this.getItemControllers().set(data.get("id"), this.createItemController(config));
    }

    /**
     *
     * @param data
     * @returns {any}
     */
    protected createItemController(data: Map<any, any>) {
        const controllerName = data.get("controllerName");
        if (controllerName && ControllerRegistry.has(controllerName)) {
            return ControllerRegistry.create(controllerName, data);
        }

        return new MenuItem(data);
    }

    protected getItemService() {
        return this.get("services");
    }

    /**
     *
     * @returns {Map}
     */
    protected getItemControllers() {
        return this.get("itemControllers");
    }

    /**
     *
     * @returns {Map}
     */
    protected getItems() {
        return this.get("items");
    }
}

ControllerRegistry.register("Menu", Menu);
